if (document.getElementById('page-recruitLow')) {
document.addEventListener("DOMContentLoaded", () => {

  const tabs = document.querySelectorAll(".recruitMain__tabBtn");
  const contents = document.querySelectorAll(".recruitMain__content");

  tabs.forEach(tab => {

    tab.addEventListener("click", () => {

      const target = tab.dataset.tab;

      // タブのactive切り替え
      tabs.forEach(btn => btn.classList.remove("is-active"));
      tab.classList.add("is-active");

      // コンテンツ切り替え
      contents.forEach(content => {

        if (content.dataset.tabContent === target) {
          content.classList.add("is-active");
        } else {
          content.classList.remove("is-active");
        }

      });

    });

  });

});
}
